<template>
  <div>
    <h3>基础信息</h3>
    <div class="mt-15px flex item-center">
      <img src="@/assets/head.png" alt="" class="w-150px h-150px mr-30rpx flex-1 object-contain" />
      <div class="ml-30px">
        <el-descriptions :column="2">
          <el-descriptions-item label="用户编号">{{ detail.number }}</el-descriptions-item>
          <el-descriptions-item label="手机号码">{{ detail.phone }}</el-descriptions-item>
          <el-descriptions-item label="归属">{{ detail.belongAgent }}</el-descriptions-item>
          <el-descriptions-item label="地区">{{ detail.area }}</el-descriptions-item>
          <el-descriptions-item label="小区">{{ detail.residentialArea }}</el-descriptions-item>
          <el-descriptions-item label="来源网点">{{ detail.registerStore }}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{
            detail.createTime | formatDate
          }}</el-descriptions-item>
          <el-descriptions-item label="上次充电时间">{{
            detail.lastChargeTime | formatDate
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{
            detail.status === 1 ? '正常' : '停用'
          }}</el-descriptions-item>
          <el-descriptions-item label="标签">{{ detail.tag }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <h3 class="mt-30px">数据详情</h3>
    <div class="mt-15px">
      <el-descriptions :column="1">
        <el-descriptions-item label="订单数">{{ detail.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="充值次数">{{ detail.rechargeCount }}</el-descriptions-item>
        <!-- <el-descriptions-item label="充值金额">{{ detail.rechargeAmount }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额">{{ detail.giveAmount }}</el-descriptions-item>
        <el-descriptions-item label="钱包余额">
          <div class="flex">
            <div class="flex center">{{ detail.wallet }}</div>
            <el-button type="text" size="mini" @click="handleWithdrawals">提现</el-button>
          </div>
        </el-descriptions-item> -->
      </el-descriptions>
    </div>
    <the-withdrawal-apply ref="checkedPwd" @confirm="handleConfirm"></the-withdrawal-apply>
  </div>
</template>

<script>
import { userDetailApi } from '@/api/user'
import theWithdrawalApply from './the-withdrawal-apply'

export default {
  components: { theWithdrawalApply },
  props: {
    code: {
      type: String,
      require: true
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      detail: {}
    }
  },
  watch: {
    info: {
      handler(val) {
        if (val) {
          this.detail = val
          console.log('用户信息 :>> ', this.detail)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getDetail(params) {
      const res = await userDetailApi(params)
      const { xdUser } = res.data
      this.detail = xdUser
    },
    handleWithdrawals() {
      this.$refs.checkedPwd.open(this.detail)
    },
    handleConfirm() {
      console.log('handleConfirm :>> ')
      this.getDetail({ code: this.code })
    }
  }
}
</script>
